import { Component, Inject } from '@angular/core';

@Component({
    selector: 'about-menu-drop-down',
    template: require('./about-menu-drop-down.component.html')
})
export class AboutMenuDropDownComponent {
    constructor(
        @Inject('$state') private $state: any
       ) {
    }

    public openGuidenceModal(event: any) {
        event.preventDefault();
        //this.shepherdGuidenceService.openGuidenceModal();
    }

    public onlineDocLink() {
        return window.open(window.__env.config.onlineDocLink,"_blank");
    }

    public navigate(event: any, sref: any) {
        event.preventDefault();
        this.$state.go(sref);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/side-menu/about-menu-drop-down/about-menu-drop-down.component.ts